import api_article from '../../../api/_article'
import api_sortie from '../../../api/_sortie'

export default {
    getMonthlyConsumption(data) {
        return new Promise((resolve, reject) => {
            api_article.getMonthlyConsumption(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getRecapSortieStock(data) {
        return new Promise((resolve, reject) => {
            api_article.getRecapSortieStock(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getDestockageListe(data) {
        return new Promise((resolve, reject) => {
            api_sortie.getDestockageListe(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}